import React from 'react';
import styled from 'styled-components';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import * as AppActions from '../../../AppActions';
import HeroBannerSection from './HeroBannerSection';
import CategoriesSection from './CategoriesSection';
import ProductsSection from './ProductsSection';
import ArticleSection from './ArticleSection';

function Landing(props) {
  const {landing} = props;

  const [products, setProducts] = React.useState(null);
  const [articles, setArticles] = React.useState(null);

  const fetchData = React.useCallback(async () => {
    if (!landing.type2_layout) {
      return;
    }

    AppActions.setLoading(true);
    try {
      //fetch products
      let productIds = landing.type2_layout.product_section?.products || [];
      let products = [];

      let _products = await JStorage.fetchDocuments(
        'product',
        {
          _id: {
            $in: [
              ...productIds.map((id) => ({
                $oid: id,
              })),
            ],
          },
        },
        null,
        null,
        null,
        {anonymous: true},
      );

      for (let id of productIds) {
        let p = _products.find((p) => p.id === id);
        products.push(p);
      }

      setProducts(products);

      //fetch articles
      let articleIds = landing.type2_layout.article_section?.articles || [];
      let articles = [];

      let _articles = await JStorage.fetchDocuments(
        'Article_Default',
        {
          _id: {
            $in: [
              ...articleIds.map((id) => ({
                $oid: id,
              })),
            ],
          },
        },
        null,
        null,
        null,
        {anonymous: true},
      );

      for (let id of articleIds) {
        let p = _articles.find((p) => p.id === id);
        articles.push(p);
      }

      setArticles(articles);
    } catch (err) {
      console.warn(err);
    }
    AppActions.setLoading(false);
  }, [landing.type2_layout]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <Wrapper>
      <HeroBannerSection landing={landing} />
      <CategoriesSection landing={landing} />
      <ArticleSection landing={landing} articles={articles} />
      <ProductsSection landing={landing} products={products} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  margin-bottom: 80px;
  padding-top: var(--topNavBarHeight);

  & .title-container {
    margin-bottom: 20px;
    text-align: center;
  }
`;

export default Landing;
